import BrandHeader from './Components/BrandHeader.vue';
import { NAVY } from '@/themes';
import { fetchBrandData } from '@/views/Brand/util';
import LoadingSpinner from '@/components/Loaders/LoadingSpinner.vue';
import BrandLogo from '@/layouts/BrandLayout/Components/BrandLogo.vue';
import OverlapSidebar from '@/components/Sidebar/OverlapSidebar.vue';
import { computed, defineComponent, onUnmounted, ref, watch, } from '@vue/composition-api';
import { useMobileView, useRouteQuery, useSidebar, useUi } from '@/composables';
import { PortalTarget } from '@/constants/portal';
import { ClientRouteName } from '@/router/router.constants';
import { isRouteName } from '@/router/utils';
export default defineComponent({
    name: 'BrandLayout',
    components: {
        BrandHeader,
        LoadingSpinner,
        BrandLogo,
        OverlapSidebar,
    },
    async beforeRouteEnter(to, from, next) {
        await fetchBrandData(to);
        next();
    },
    async beforeRouteUpdate(to, from, next) {
        await fetchBrandData(to);
        next();
    },
    setup(_, ctx) {
        const { sidebar, changeTheme, toggleSidebar, sideMenu, toggleSideMenu } = useUi();
        const { isMobileView } = useMobileView();
        const { loading } = useRouteQuery(ctx);
        const { showSidebar } = useSidebar(ctx);
        const sidebarRef = ref(null);
        const isReportList = computed(() => isRouteName(ctx, ClientRouteName.REPORTS));
        const isReportDetails = computed(() => isRouteName(ctx, ClientRouteName.REPORT_DETAILS));
        watch(isMobileView, () => {
            if (showSidebar) {
                toggleSidebar();
            }
        });
        onUnmounted(() => {
            changeTheme(NAVY);
        });
        const storeHeaderOffset = computed(() => {
            const offsets = ctx.root.$store.state.ui && ctx.root.$store.state.ui.offsets;
            return (offsets && (offsets.navBarBrand || offsets.navBar)) || 0;
        });
        const topPadding = computed(() => {
            // On mobile report details BrandHeader is hidden, so we must not reserve space for it.
            if (isReportDetails.value && isMobileView.value) {
                return 0;
            }
            // BrandHeader keeps ui.offsets.navBarBrand in sync (dynamic banners included).
            return storeHeaderOffset.value || 0;
        });
        return {
            sidebarRef,
            topPadding,
            sidebar,
            sideMenu,
            changeTheme,
            toggleSidebar,
            toggleSideMenu,
            isMobileView,
            loading,
            showSidebar,
            PortalTarget,
            isReportList,
            isReportDetails,
        };
    },
});
